import { gameState } from "appworks/model/game-state";
import { UIFlag, uiFlags } from "appworks/ui/flags/ui-flags";
import { Contract } from "appworks/utils/contracts/contract";
import { Parallel } from "appworks/utils/contracts/parallel";
import { PartnerConnectRestoreSpinCommand } from "partner-connect/commands/partner-connect-restore";
import { StartSpinCommand } from "slotworks/commands/comms/start-spin-command";
import { FreespinRecord } from "slotworks/model/gameplay/records/freespin-record";
import { PartnerConnectRequestSpin } from "./partner-connect-request-spin";

export class PartnerConnectRecoverySpin extends PartnerConnectRequestSpin {
    public onEnter(cascadeSkip?: boolean) {
        gameState.autoDeductStake = false;
        super.onEnter(cascadeSkip);
    }

    protected startSpinning(): Contract<any> {

        return new Parallel([
            () => StartSpinCommand(),
            () => PartnerConnectRestoreSpinCommand(),
            () => Contract.wrap(() => {
                gameState.getCurrentGame().setToLatestRecord();
                gameState.autoDeductStake = true;
                if (gameState.getCurrentGame().getCurrentRecord() instanceof FreespinRecord && gameState.getCurrentGame().getCurrentRecord().getFreespinsWon() === 0) {
                    uiFlags.set(UIFlag.FREE_SPINS, true);
                }
            })
        ]);
    }
}
